import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCvx: [],
		cvx: null,
		selectedCvx: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lstCvz: [],
	},
	getters: {
		cvxmodel(state){
			let cvx = state.cvx
			cvx.lstCvz = state.lstCvz
			for (const cvz of cvx.lstCvz) {
				cvz.cvzlista = state.cvx.cvxlista
				cvz.cvzcliente = state.cvx.cvxcliente
			}
			
			return cvx
		}
	},
	mutations: {
		set(state, cvx){
			state.cvx = cvx
			if (cvx){
				state.update = true
				state.lstCvz = cvx.lstCvz
			}
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cvx = null
			state.lstCvz = []
		},
		setParamsDataTable(state, payload){
			state.lstCvx = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, {cvxlista, cvxcliente}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByCustomer/Find/${cvxlista}/${cvxcliente}`)
			.then(response => {
				let cvx = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", cvx)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Price/SpecialPriceByCustomer/Insert", store.getters.cvxmodel )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-cliente")
				store.state.cvx = null
				store.state.lstCvz = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Price/SpecialPriceByCustomer/Update", store.getters.cvxmodel )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-cliente")
				store.state.cvx = null
				store.state.lstCvz = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Price/SpecialPriceByCustomer/Delete/${store.state.cvx.cvxlista}/${store.state.cvx.cvxcliente}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-cliente")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByCustomer/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCvx = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}